import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import {
  getFormQuestionAttributeStartDateQuestionUuid,
  getFormQuestionAttributeStartDateQuestionUuidOptions,
  setQuestionAttributeStartDateQuestionUuid,
} from "reduxSlices/formBuilderSlice"
import { QuestionSelect } from "shared/selects"

const StartDateQuestionUuid = ({ sectionIndex, questionIndex }) => {
  const dispatch = useDispatch()

  const questionStartDateQuestionUuid = useSelector(getFormQuestionAttributeStartDateQuestionUuid({ sectionIndex, questionIndex }))
  const questionStartDateQuestionOptions = useSelector(getFormQuestionAttributeStartDateQuestionUuidOptions({ sectionIndex, questionIndex }), isEqual)

  const updateStartDateQuestionUuid = (newStartDateQuestionUuid) => dispatch(setQuestionAttributeStartDateQuestionUuid({
    sectionIndex, questionIndex, newStartDateQuestionUuid,
  }))

  return (
    <QuestionSelect
      backspaceDelete={false}
      className="text-sm"
      isFullWidth
      onChange={updateStartDateQuestionUuid}
      placeholder="Start date"
      questions={questionStartDateQuestionOptions}
      selectLabel="select start date question"
      selectedQuestionUuid={questionStartDateQuestionUuid}
      style={{ height: "32px" }}
    />
  )
}

StartDateQuestionUuid.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default StartDateQuestionUuid
